import Component from 'react-swipeable-views';

// @ts-ignore
const ReactSwipeableViews = Component.default || Component;

export { ReactSwipeableViews as default };
